import { cacheDom } from "../utils/QuerySelectors.js"
import { formatPlayerTime, isMobile, videoHtml } from "../utils/helpers.js"

const dom = {}
const qs = {
  playPause: 'data-play-pause',
  mute: 'data-mute',
  fullscreen: 'data-fullscreen',
  duration: 'data-duration',
  current: 'data-current',
  track: 'data-track',
  road: 'data-road',
  controls: 'data-video-controls',
  json: 'data-video-json',
}
const qsAll = {
  videos: 'data-video-component',  
}

const state = {
  videoDuration: 1,
}

const playVideo = (videoWrapper) => {
  const video = videoWrapper.querySelector('video')
  video.play()
  videoWrapper.querySelector('.icon-pause').classList.remove('hidden')
  videoWrapper.querySelector('.icon-play').classList.add('hidden')
}

const pauseVideo = (videoWrapper) => {
  const enable = videoWrapper.dataset.controls == 'true'
  if(enable) {
    const video = videoWrapper.querySelector('video')
    video.pause()
    videoWrapper.querySelector('.icon-pause').classList.add('hidden')
    videoWrapper.querySelector('.icon-play').classList.remove('hidden')
  }
}
const toggleMute = (videoWrapper, muteBtn) => {
  const enable = videoWrapper.dataset.controls == 'true'
  if(enable) {
    const video = videoWrapper.querySelector('video')
    video.muted = !video.muted
    if(video.muted) {
      muteBtn.innerHTML = 'Unmute'
    } else {
      muteBtn.innerHTML = 'Mute'
    }
  }
}
const updateDuration = (videoWrapper) => {
  const video = videoWrapper.querySelector('video')
  state.videoDuration = video.duration
  videoWrapper.querySelector(`[${qs.duration}]`).innerHTML = formatPlayerTime(video.duration)
}

const initVideoControls = (videoWrapper) => {
  const enable = videoWrapper.dataset.controls == 'true'
  if(enable) {
    const video = videoWrapper.querySelector('video')
    const controls = videoWrapper.querySelector(`[${qs.controls}]`)

    if(isMobile()) {
      controls.classList.add('!hidden')
      return
    }

    const road = videoWrapper.querySelector(`[${qs.road}]`)
    const playPauseBtn = videoWrapper.querySelector(`[${qs.playPause}]`)
    const muteBtn = videoWrapper.querySelector(`[${qs.mute}]`)
    const fullscreenBtn = videoWrapper.querySelector(`[${qs.fullscreen}]`)
    
    muteBtn.addEventListener('click', () => {
      toggleMute(videoWrapper, muteBtn)
    })
    
    fullscreenBtn.addEventListener('click', () => {
      if (document.fullscreenElement) {
        if (document.exitFullscreen)
          document.exitFullscreen()
        else if (document.webkitExitFullscreen) /* Safari */
          document.webkitExitFullscreen()
        else if (document.msExitFullscreen) /* IE11 */
          document.msExitFullscreen()
      } else {
        if (videoWrapper.requestFullscreen)
          videoWrapper.requestFullscreen()
        else if (videoWrapper.webkitRequestFullscreen) /* Safari */
          videoWrapper.webkitRequestFullscreen()
        else if (videoWrapper.msRequestFullscreen) /* IE11 */
          videoWrapper.msRequestFullscreen()
        fullscreenBtn.innerHTML = 'Exit Full Screen'
      }
    })
    videoWrapper.addEventListener("fullscreenchange", () => {
      if (document.fullscreenElement) {
        fullscreenBtn.innerHTML = 'Exit Full Screen'
      } else {
        fullscreenBtn.innerHTML = 'Full Screen'
      }
    })
    playPauseBtn.addEventListener('click', () => {
      if(video.paused)
        playVideo(videoWrapper)
      else
        pauseVideo(videoWrapper)
    })
    updateDuration(videoWrapper)
    video.oncanplay = () => {
      updateDuration(videoWrapper)
    }
    setInterval(() => {
      videoWrapper.querySelector(`[${qs.current}]`).innerHTML = formatPlayerTime(video.currentTime)
      videoWrapper.querySelector(`[${qs.track}]`).style.width = `${video.currentTime / state.videoDuration * 100.0}%`
    }, 200)
    road.addEventListener('click', (e) => {
      video.currentTime = state.videoDuration * e.offsetX / road.offsetWidth
    })
    controls.addEventListener('click', (e) => {
      e.stopPropagation()
      e.preventDefault()
    })
  }
  videoWrapper.dataset.inited = true
}

const iObserver = new IntersectionObserver(items => {
  if (items[0].isIntersecting) {
    const videoWrapper = items[0].target
    const json = JSON.parse(videoWrapper.querySelector(`[${qs.json}]`).innerHTML)
    if(!videoWrapper.dataset.inited && videoWrapper.querySelector(`[${qs.json}]`)) {
      videoWrapper.innerHTML = videoHtml(json, 'w-full h-full object-center object-cover') + videoWrapper.innerHTML
      initVideoControls(videoWrapper)
    }
  }
})

export const setupVideos = () => {
  cacheDom(dom, qs, qsAll)
  window.addEventListener('resize', () => {
    if(window.innerWidth < 768) dom.videos.forEach(videoWrapper => pauseVideo(videoWrapper))
  })
  window.addEventListener('orientationchange', () => {
    if(window.innerWidth < 768) dom.videos.forEach(videoWrapper => pauseVideo(videoWrapper))
  })
  dom.videos.forEach(video => {
    if(!video.dataset.inited) {
      if(video.querySelector('video')) {
        initVideoControls(video)
      } else if(video.querySelector(`[${qs.json}]`)) {
        iObserver.observe(video)
      }
    }
  })
}